import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from "@angular/core";
import { VoterSearchAPIService } from "src/app/voter-search/services/api/api.service";
import * as _ from "underscore";

@Component({
  selector: "app-lastname-search",
  templateUrl: "./lastname-search.component.html",
  styleUrls: ["./lastname-search.component.scss"],
})
export class LastnameSearchComponent implements OnInit {
  searchFormModel: any;//IN_SearchByWild;
  lastNameListData: any;
  lastNameListCount:number = 0;
  errorFlag: boolean = false;

  @ContentChild("Template_CommonFiltersContainer", { static: false })
  commonFilterTemplate: TemplateRef<any>;
  @Input() commonFormFilterObject:any = {};
  @Input() commonFormFilterInputParams:any = {};
  @Output() onSearchTriChild = new EventEmitter();
  @Output() lastNameListDataChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() UpdatedLastname;
  message: any;
  sharedData: string;


  constructor( private service: VoterSearchAPIService,
  ) {
    this._init();
  }
  
  receiveMessage($event:any) {
    this.message = $event;
  }


  _triggerSearch() {
    let searchPayloadModel:any = {};
    let dd = {};

    if(this.searchFormModel.filters){
     dd = JSON.parse(JSON.stringify(this.searchFormModel.filters));
    }
    let ddd = {};
    if(this.commonFormFilterObject){
     ddd = JSON.parse(JSON.stringify(this.commonFormFilterObject));
    }
    
    this.searchFormModel.filters = { ...dd, ...ddd };
     if(this.searchFormModel.filters.boothName){
       this.searchFormModel.filters.boothName = this.searchFormModel.filters.boothName.boothName;
     }

    searchPayloadModel = this._processLocalVariables(searchPayloadModel);
     
   this.onSearchTriChild.emit({
     data: JSON.parse(JSON.stringify(this.searchFormModel)),
   });
  }

  triggerSearch(voterSearchForm) {
    //form related activity or validation
    this._triggerSearch();

  }

  _processLocalVariables(searchPayloadModel){
    return searchPayloadModel;
  }

  private getLastNameList(searchText){
   this.service.initSurnameListData(searchText).subscribe((resp: any) => {
      this.lastNameListData = resp;
      this.lastNameListCount = this.lastNameListData.length;
      this.lastNameListDataChanged.emit(this.lastNameListData);
    });

  }

  private _init() {
    this.getLastNameList('null')
    this.searchFormModel = {
      type: "BYNAME",
      filters: {},
      page: {
        number: 0,
        size: 10,
      },
    };
  }

  clearModel() {
    this._init();
    this.errorFlag = false;
    this.onSearchTriChild.emit({
      actionMode:"RESET",
      data: JSON.parse(JSON.stringify(this.searchFormModel))
    });
  }
  updateLname(lastNameObj): void {
    this.searchFormModel.filters.lastName = lastNameObj.lastName;
  }

  ngOnInit() {
    this._init();
    this.service.sharedData$.subscribe(data => {
      if(data != 'Initial Value'){
        this.searchFormModel.filters.lastName=data;
        this._triggerSearch();  
      }
      // this.sharedData = data;
    });
  }
}
